<div class="modal-header">
    <h4 class="modal-title">{{ titleTranslation | translate }}</h4>
    <img class="pointer" width="24" height="24" alt="close" src="assets/img/close.svg" (click)="close()">
</div>
<div class="modal-body" *ngIf="isHtml" [innerHTML]="modalInformation">
</div>
<div class="modal-body" *ngIf="!isHtml">
    {{ modalInformation | translate }}
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-outline-dark" [style.backgroundColor]="catalogueService.getProperty('mainColor')" [style.color]="catalogueService.getProperty('languageColor')" (click)="close()">{{ 'MODAL_FOOTER.CLOSE' | translate }}</button>
</div>
